import { render, staticRenderFns } from "./UnlockFailedModal.vue?vue&type=template&id=679e8488&scoped=true"
import script from "./UnlockFailedModal.vue?vue&type=script&lang=js"
export * from "./UnlockFailedModal.vue?vue&type=script&lang=js"
import style0 from "./UnlockFailedModal.vue?vue&type=style&index=0&id=679e8488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679e8488",
  null
  
)

export default component.exports